import React from "react"
import DetailsMain from "../../components/templates/DetailsMain"

import { DetailsContainer } from "./style"

function Details() {
  return (
    <DetailsContainer>
      <DetailsMain />
    </DetailsContainer>
  )
}

export default Details
